import axios, { AxiosError, AxiosInstance } from 'axios'
import { generateRecaptchaToken } from '../common/recapctcha'
import { RecaptchaPayload } from '../common/slice'
import { FloodInformationData } from '../components/flood-components/slice'
import RecaptchaRequiredError from '../errors/RecaptchaRequiredError'
import {
    FLOOD_IMPACT_SEARCH_PATH,
    OPEN_LAYERS_BASE_URL,
    OPEN_LAYERS_WFS_NTLIS_PATH,
    RECAPTCHA_ENABLED
} from "../environment"

const AXIOS_CONFIG = {
  headers: { 'X-RDS-AJAX': 'true', 'Accept-Language': 'en-AU' },
  baseURL: FLOOD_IMPACT_SEARCH_PATH,
  withCredentials: true,
}

export interface GetFloodInformationApiProps extends RecaptchaPayload {
  laisKey: string
}

class FloodServiceAPI {
    client:AxiosInstance
    floodGeoClient:AxiosInstance

    constructor() {
        this.client = axios.create(AXIOS_CONFIG)
        this.floodGeoClient = axios.create()
    }

    getFloodGeoDataApi = async (laisKey: string) => {
        let cqlFilter = '';
        laisKey = laisKey.replaceAll('X', ' ');
        cqlFilter = `LAISKEY='${laisKey}'`

        const featureRequest = {
            service: 'WFS',
            version: '1.0.0',
            request: 'GetFeature',
            srsName: 'EPSG:4283',
            typeName: 'ntlis:CADASTRE',
            outputFormat: 'application/json',
            cql_filter: cqlFilter
        }

        let body = new URLSearchParams(featureRequest);

        if (OPEN_LAYERS_WFS_NTLIS_PATH != null) {
            let projectData = await this.floodGeoClient.post(OPEN_LAYERS_WFS_NTLIS_PATH,
                body,
                {
                    baseURL: OPEN_LAYERS_BASE_URL,
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
                    },
                })
            if (projectData) {
                return projectData.data.features[0].geometry;
            }
        }
    }

  getFloodInformationApi = async (payload: GetFloodInformationApiProps) => {
    if (RECAPTCHA_ENABLED) {
      const isV3Captcha = !payload.recaptchaV2Code
      const recaptchaToken = await generateRecaptchaToken()
      try {
        let floodData = await this.client.get<FloodInformationData>('/dataWithRecaptcha', {
          params: {
            laisKey: payload.laisKey.replaceAll('X', ' '),
            [isV3Captcha ? 'recaptchaV3Key' : 'recaptchaV2Key']: recaptchaToken,
          },
        })
        return floodData.data
      } catch (error: any) {
        return this.handleError(error)
      }
    } else {
      try {
        let floodData = await this.client.get<FloodInformationData>('/data', { params: { laisKey: payload.laisKey.replaceAll('X', ' ') } })
        return floodData.data
      } catch (error: any) {
        return this.handleError(error)
      }
    }
  }


  getFloodInfoPdfApi = async (laisKey: string) => {
    return await this.client.get<BlobPart>('/downloadpdf', {
      params: { laisKey: laisKey.replaceAll('X', ' ') },
      responseType: 'blob',
    })
  }

  handleError = (error: any) => {
    if (error && error.response && error.response.data && error.response.data.type === 'INVALID_CAPTCHA') {
      // V3 recaptcha failed (low score) force V2 recaptcha
      throw new RecaptchaRequiredError('error.response.data.type', 'Recaptcha failed (V3), manual Recaptcha required! (V2)')
    } else if (error.message !== 'CANCEL') {
      throw error
    }
  }
}

const floodServiceAPI = new FloodServiceAPI()

export default floodServiceAPI